var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-left":"50px"}},[_c('a-transfer',{attrs:{"list-style":{
    width: '400px',
    height: '500px',
  },"data-source":_vm.project.unit_all,"titles":['可选单位', '已选单位'],"selected-keys":_vm.selectedKeys,"target-keys":_vm.project.unit_selected_key_list,"render":item => item.name,"disabled":_vm.disabled},on:{"change":_vm.handleChange,"selectChange":_vm.handleSelectChange,"scroll":_vm.handleScroll}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }